/// <reference types="vite-plugin-svgr/client" />
import {
  FormControl,
  FormControlLabel,
  FormHelperText,
  Grid,
  Radio,
  RadioGroup,
  TextField,
  Typography,
} from '@mui/material';
import { Controller, useFormContext } from 'react-hook-form';

import BankCheckImage from '~/assets/images/bank-check-v2.svg?react';
import { text } from '~/modules/@shared/helpers/text';

export function ACHForm() {
  const {
    control,
    formState: { errors },
  } = useFormContext();

  return (
    <>
      <Grid item xs={12} sx={{ display: 'flex', alignItems: 'center' }}>
        <Typography sx={{ mt: 2 }} variant="caption">
          Account Type
        </Typography>
        {!!errors.account_type && <FormHelperText error>Required</FormHelperText>}
      </Grid>
      <Grid item xs={12} sx={{ display: 'flex', alignItems: 'center' }}>
        <Controller
          control={control}
          name="account_type"
          render={({ field: { value, ...field } }) => (
            <FormControl fullWidth>
              <RadioGroup {...field} row value={value ?? ''} sx={{ justifyContent: 'flex-start' }}>
                <FormControlLabel value="checking" control={<Radio />} label="Personal Checking" />
                <FormControlLabel value="savings" control={<Radio />} label="Personal Savings" />
              </RadioGroup>
            </FormControl>
          )}
        />
      </Grid>
      <Grid item xs={12} sx={{ my: 1 }}>
        <Controller
          control={control}
          name="routing_number"
          render={({ field: { value, ...field } }) => (
            <FormControl fullWidth>
              <Typography variant="caption" sx={{ display: 'block', mb: 1 }}>
                Routing Number
              </Typography>
              <TextField
                {...field}
                value={value ?? ''}
                placeholder="123456789"
                error={!!errors.routing_number}
                helperText={text(errors.routing_number?.message)}
                FormHelperTextProps={{ error: true }}
                InputLabelProps={{ shrink: true }}
              />
              {!!errors.routing_number && <FormHelperText error>Required</FormHelperText>}
            </FormControl>
          )}
        />
      </Grid>
      <Grid item xs={12} sx={{ my: 1 }}>
        <Controller
          control={control}
          name="bank_account_number"
          render={({ field: { value, ...field } }) => (
            <FormControl fullWidth>
              <Typography variant="caption" sx={{ display: 'block', mb: 1 }}>
                Bank Account Number
              </Typography>
              <TextField
                {...field}
                value={value ?? ''}
                placeholder="123456789012"
                error={!!errors.bank_account_number}
                helperText={text(errors.bank_account_number?.message)}
                FormHelperTextProps={{ error: true }}
                InputLabelProps={{ shrink: true }}
              />
              {!!errors.bank_account_number && <FormHelperText error>Required</FormHelperText>}
            </FormControl>
          )}
        />
      </Grid>
      <Grid item xs={12} sm={12}>
        <BankCheckImage height="100%" width="100%" style={{ width: '100%' }} />
      </Grid>
    </>
  );
}
